import './banner-2-3-4.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.InitBanner234 = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.banner-2-3-4__section'), (el) => {
    window.dAgency.InitBanner234(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.banner-2-3-4__section'), (el) => {
      window.dAgency.InitBanner234(el);
    });
  });
}
